import type { GetSigninResponse } from '../get';
import {
	postGenericEndpoint,
	type PostGenericEndpointParams,
} from './post.api';
import type { PostResetPasswordRequest } from './types';

export const postResetPassword = async ({
	data,
	lang,
	token,
}: PostGenericEndpointParams<PostResetPasswordRequest>): Promise<GetSigninResponse> => {
	return await postGenericEndpoint({
		data,
		lang,
		token,
		path: 'forgotten/reset',
	});
};
